import styles from './BlockTitle.module.scss';

type BlockTitleProps = {
    title: string;
    style?: React.CSSProperties;
}

const BlockTitle: React.FC<BlockTitleProps> = ({ title, style }) => {
    return (
        <h3 className={styles.title} style={style} dangerouslySetInnerHTML={{ __html: title }}></h3>
    );
}

export default BlockTitle;
